import { Pipe, inject, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'formatNumber' })
export class FormatNumberPipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);

  transform(value: string | number, digitsInfo = ''): string | null {
    return this.decimalPipe.transform(value, digitsInfo, 'de-AT');
  }
}
@Pipe({ name: 'numberFormat' })
export class NumberFormatPipe implements PipeTransform {
  transform(value: string | number | undefined): string {
    if (value === undefined) return '';
    let castNum: number;
    if (Number.isNaN(value)) {
      castNum = parseFloat('' + value);
    } else {
      castNum = value as number;
    }
    return new Intl.NumberFormat('de-AT', { style: 'decimal' }).format(castNum);
  }
}
